import { Component, Input } from '@angular/core';
import { UserProfile } from '../models/userProfile';

@Component({
	selector: 'app-user-avatar',
	templateUrl: './user-avatar.component.html',
	styleUrls: ['./user-avatar.component.less']
})
export class UserAvatarComponent {
	
	@Input() user!: UserProfile;

	constructor() { 
		
	}

	get initials(): string {
		//console.log(this.user.firstName);
		return this.user.firstName.charAt(0) + " " + this.user.lastName.charAt(0);
	}

	get avatarUrl(): string | null | undefined {
		return null;//"https://cdn.shopify.com/s/files/1/0170/5859/4880/files/cartmanOverlay_1980x.png?v=1613773493";
	}

}
